import { useDictionary } from "@adamlip/okeoke.client";
import { Button } from "@nextui-org/react";
import anime from "animejs";
import { UserContext } from "contexts/UserContext";
import { useContext, useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
function UsePoints({ setIsOpen }) {
  const rangeWrapperRef = useRef(null);
  const rangeInputRef = useRef(null);
  const rangeValuesRef = useRef(null);
  const rangeValueNumberTopRef = useRef(null);
  const rangeValueNumberBottomRef = useRef(null);
  const rangeSliderPathsRef = useRef(null);
  const {
    userVipPoints: points,
    setUsePoints,
  } = useContext(UserContext);
  const [claimValue, setClaimValue] = useState(null);
  const { getValue } = useDictionary();

  useEffect(() => {
    if (
      (rangeInputRef?.current,
        rangeWrapperRef,
        rangeValuesRef,
        rangeValueNumberBottomRef,
        rangeValueNumberTopRef,
        rangeSliderPathsRef)
    ) {
      var rangeSliderPaths = document.querySelectorAll(".range__slider__path");

      var mouseX = 0;
      var mouseY = 0;
      var mouseInitialY = 0;
      var mouseDy = 0;
      var mouseDyLimit = 150;
      var mouseDyFactor = 3;
      var max = 100;
      var rangeMin = parseInt(rangeInputRef?.current?.min);
      var rangeMax = parseInt(rangeInputRef?.current?.max);
      var rangeValue = parseInt(rangeInputRef?.current?.value);
      var rangeHeight = 480;
      var currentY = (rangeHeight * rangeValue) / max;
      var rangeMinY = (rangeHeight * rangeMin) / max;
      var rangeMaxY = (rangeHeight * rangeMax) / max;
      var scaleMax = 0.32;
      var scale,
        newPath,
        newY,
        newSliderY,
        lastMouseDy,
        rangeWrapperLeft,
        pageX,
        pageY = 0;
      updateValue();

      function buildPath(dy, ty) {
        return (
          "M 0 " + ty + " q " + mouseX + " " + dy + " 320 0 l 0 480 l -320 0 Z"
        );
      }
      function updateValue() {
        anime.remove([
          rangeValuesRef?.current,
          rangeValuesRef?.current?.children[0],
          rangeSliderPaths[1],
        ]);

        rangeValue = parseInt((currentY * max) / rangeHeight);
        scale = ((rangeValue - rangeMin) / (rangeMax - rangeMin)) * scaleMax;
        rangeInputRef.current.value = rangeValue;
        setClaimValue((points * rangeValue) / 100);
        rangeValueNumberTopRef.current.innerText = `${max - rangeValue}%`;
        rangeValueNumberBottomRef.current.innerText = `${rangeValue}%`;
        rangeValuesRef.current.style.transform =
          "translateY(" + (rangeHeight - currentY) + "px)";
        rangeValueNumberTopRef.current.style.transform =
          "scale(" + (1 - scale) + ")";
        rangeValueNumberBottomRef.current.style.transform =
          "scale(" + (1 - (scaleMax - scale)) + ")";

        // Some maths calc
        if (Math.abs(mouseDy) < mouseDyLimit) {
          lastMouseDy = mouseDy;
        } else {
          lastMouseDy = mouseDy < 0 ? -mouseDyLimit : mouseDyLimit;
        }

        newSliderY = currentY + lastMouseDy / mouseDyFactor;
        if (newSliderY < rangeMinY || newSliderY > rangeMaxY) {
          newSliderY = newSliderY < rangeMinY ? rangeMinY : rangeMaxY;
        }

        newPath = buildPath(lastMouseDy, rangeHeight - newSliderY);
        rangeSliderPaths[0].setAttribute("d", newPath);
        rangeSliderPaths[1].setAttribute("d", newPath);
      }
      function elasticRelease() {
        // Morph the paths to the opposite direction, to simulate a strong elasticity
        anime({
          targets: rangeSliderPaths,
          d: buildPath(
            -lastMouseDy * 1.3,
            rangeHeight - (currentY - lastMouseDy / mouseDyFactor)
          ),
          duration: 150,
          easing: "linear",
          complete: function () {
            // Morph the paths to the normal state, using the `elasticOut` easing function (default)
            anime({
              targets: rangeSliderPaths,
              d: buildPath(0, rangeHeight - currentY),
              duration: 4000,
              elasticity: 880,
            });
          },
        });

        // Translate the values to the opposite direction, to simulate a strong elasticity
        anime({
          targets: rangeValuesRef?.current,
          translateY:
            rangeHeight - (currentY + lastMouseDy / mouseDyFactor / 4),
          duration: 150,
          easing: "linear",
          complete: function () {
            // Translate the values to the right position, using the `elasticOut` easing function (default)
            anime({
              targets: rangeValuesRef?.current,
              translateY: rangeHeight - currentY,
              duration: 4000,
              elasticity: 880,
            });
          },
        });
      }

      function mouseDown(e) {
        mouseY = mouseInitialY = e.targetTouches
          ? e.targetTouches[0].pageY
          : e.pageY;
        rangeWrapperLeft =
          rangeWrapperRef?.current.getBoundingClientRect().left;
      }
      function mouseMove(e) {
        if (mouseY) {
          pageX = e.targetTouches ? e.targetTouches[0].pageX : e.pageX;
          pageY = e.targetTouches ? e.targetTouches[0].pageY : e.pageY;
          mouseX = pageX - rangeWrapperLeft;
          mouseDy = (pageY - mouseInitialY) * mouseDyFactor;
          newY = currentY + mouseY - pageY;
          if (newY >= rangeMinY && newY <= rangeMaxY) {
            currentY = newY;
            mouseY = pageY;
          } else {
            currentY = newY < rangeMinY ? rangeMinY : rangeMaxY;
          }
          // After doing maths, update the value
          updateValue();
        }
      }
      function mouseUp() {
        // Trigger elastic animation in case `y` value has changed
        if (mouseDy) {
          elasticRelease();
        }
        // Reset values
        mouseY = mouseDy = 0;
      }
      rangeWrapperRef?.current.addEventListener("mousedown", mouseDown);
      rangeWrapperRef?.current.addEventListener("touchstart", mouseDown);
      rangeWrapperRef?.current.addEventListener("mousemove", mouseMove);
      rangeWrapperRef?.current.addEventListener("touchmove", mouseMove);
      rangeWrapperRef?.current.addEventListener("mouseup", mouseUp);
      rangeWrapperRef?.current.addEventListener("mouseleave", mouseUp);
      rangeWrapperRef?.current.addEventListener("touchend", mouseUp);
    }
  }, [
    rangeInputRef,
    rangeWrapperRef,
    rangeValuesRef,
    rangeValueNumberBottomRef,
    rangeValueNumberTopRef,
    rangeSliderPathsRef,
    points,
  ]);
  const handleClaimPoints = () => {
    if (typeof setUsePoints === "function") {
      setUsePoints(parseInt(claimValue)).then((response) => {
        if (response?.success) {
          toast.success(getValue("app_v2_vip_claimSuccess"));
          setIsOpen(false);
        }
        console.log(response);
      });
    }
  };
  return (
    <div className="flex flex-col items-center justify-start h-full w-full text-center pb-20">
      <div className="range__wrapper" ref={rangeWrapperRef}>
        <input
          aria-label="input"
          className="range__input"
          type="range"
          min="0"
          max="100"
          value="64"
          ref={rangeInputRef}
        />
        <svg
          className="range__slider"
          width="320px"
          height="480px"
          viewBox="0 0 320 480"
          ref={rangeSliderPathsRef}
        >
          <defs>
            <symbol id="range__marks" shapeRendering="crispEdges">
              <path className="range__marks__path" d="M 257 30 l 33 0"></path>
              <path className="range__marks__path" d="M 268 60 l 22 0"></path>
              <path className="range__marks__path" d="M 278 90 l 12 0"></path>
              <path className="range__marks__path" d="M 278 120 l 12 0"></path>
              <path className="range__marks__path" d="M 278 150 l 12 0"></path>
              <path className="range__marks__path" d="M 278 180 l 12 0"></path>
              <path className="range__marks__path" d="M 278 210 l 12 0"></path>
              <path className="range__marks__path" d="M 278 240 l 12 0"></path>
              <path className="range__marks__path" d="M 278 270 l 12 0"></path>
              <path className="range__marks__path" d="M 278 300 l 12 0"></path>
              <path className="range__marks__path" d="M 278 330 l 12 0"></path>
              <path className="range__marks__path" d="M 278 360 l 12 0"></path>
              <path className="range__marks__path" d="M 278 390 l 12 0"></path>
              <path className="range__marks__path" d="M 268 420 l 22 0"></path>
              <path className="range__marks__path" d="M 257 450 l 33 0"></path>
            </symbol>
            <clipPath id="range__slider__clip-path">
              <path
                className="range__slider__path"
                d="M 0 480 l 320 0 l 0 480 l -320 0 Z"
              ></path>
            </clipPath>
          </defs>
          <use href="#range__marks" className="range__marks__pink"></use>
          <path
            className="range__slider__path"
            d="M 0 480 l 320 0 l 0 480 l -320 0 Z"
          ></path>
          <use
            href="#range__marks"
            className="range__marks__white"
            clipPath="url(#range__slider__clip-path)"
          ></use>
        </svg>

        <div className="range__values" ref={rangeValuesRef}>
          <div className="range__value range__value--top">
            <span
              className="range__value__number range__value__number--top"
              ref={rangeValueNumberTopRef}
            ></span>
            <span className="range__value__text range__value__text--top">
              <span>{getValue("app_v2_vip_points")}</span>
              <span>{getValue("app_v2_vip_toKeep")}</span>
            </span>
          </div>
          <div className="range__value range__value--bottom">
            <span
              className="range__value__number range__value__number--bottom"
              ref={rangeValueNumberBottomRef}
            ></span>
            <span className="range__value__text range__value__text--bottom">
              <span>{getValue("app_v2_vip_points")}</span>
              <span>{getValue("app_v2_vip_toUse")}</span>
            </span>
          </div>
        </div>
      </div>

      <div className="text-lg font-bold absolute bottom-2">
        <p className="text-current">
          {getValue("app_v2_vip_pointsLabel")}: {points}
        </p>
        <p className="text-primary">
          {getValue("app_v2_vip_youWillClaim")} {parseInt(claimValue)}
        </p>
        <Button onClick={() => handleClaimPoints()} color="primary">
          {getValue("app_v2_vip_claim")}
        </Button>
      </div>
    </div>
  );
}

export default UsePoints;
